<template>  
  <v-app app>                
    <v-main>
      <v-card class="mx-auto" max-width="448" v-if="$route.name!='LOGIN'">
        <v-app-bar color="light-green-darken-4" density="compact">
          <template v-slot:prepend>
            <v-btn value="home" @click="$router.push('/');">
              <tr><td class="bg-light-green-darken-4"><v-icon size="large">mdi-home</v-icon></td></tr>
            </v-btn>
          </template>
          <v-app-bar-title v-if="$store.state.company_name!=undefined">
            <tr>
              <td class="bg-light-green-darken-4">
                {{ $store.state.company_name }}
                <v-divider vertical></v-divider>
                {{ $store.state.city_name }}
                <v-divider vertical></v-divider>
                <strong v-if="$route.name!='HOME'">{{ $route.name }}</strong>                
              </td>
            </tr>
          </v-app-bar-title>
          <template v-slot:append>
            <v-btn value="exit" @click="cerrarSesion();">
              <tr><td class="bg-light-green-darken-4"><v-icon size="large">mdi-power</v-icon></td></tr>
            </v-btn>
          </template>
        </v-app-bar>
      </v-card>

      <v-navigation-drawer permanent v-if="$route.name !== 'LOGIN'" expand-on-hover>
        <v-list density="comfortable" nav>
          <v-list-item prepend-icon="mdi-food-fork-drink" title="Categorias" value="categories" @click="goView('/categories')" color="warning"></v-list-item>
          <v-list-item prepend-icon="mdi-food-apple" title="Productos" value="productos" @click="goView('/products')" color="warning"></v-list-item>
          <v-list-item prepend-icon="mdi-account-tie" title="Vendedores" value="vendor" @click="goView('/vendors')" color="warning"></v-list-item>
          <v-list-item prepend-icon="mdi-account" title="Clientes" value="customer" @click="goView('/customers')" color="warning"></v-list-item>
          <v-list-item prepend-icon="mdi-volume-high" title="Audios Vendedores" value="audiovendors" @click="goView('/audios_vendors')" color="warning"></v-list-item>
        </v-list>
      </v-navigation-drawer>

      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
  import Home from './components/Home.vue';
  import Swal from 'sweetalert2';
  import API from './api';
  import {ref,onUnmounted} from 'vue';
  
  export default {
    name: 'App',
    components: {
      Home,
    },
    data () {
      return {
        token_street_shopping: null,
        dialog: false,
        is_user_connected: "false",
        loaded: false,
        loading: false,
        rulestxt: [v => v.length <= 37 || 'Max 37 characters'],
      }
    },
    mounted() {
    },
    methods: {            
      goView(path_route) {
        if (path_route === '/chat') {
          this.$router.push(path_route);
        } else {
          this.ejectApp();
          if (this.order_accepted == 0 && this.is_user_connected == 'false') {
            this.$router.push(path_route);
          }
        }
        this.ver_menu_tres_puntos = false;
        this.ver_menu_lateral = false;
      },

      ejectApp() {
        this.is_user_connected = localStorage.getItem('is_connected_street_shopping');
        this.order_accepted = localStorage.getItem('order_accepted_street_shopping');
        if (this.order_accepted == null) {
          this.order_accepted = 0;
        }
        if (this.is_user_connected == null) {
          this.is_user_connected = 'false';
        }
      },

      cerrarSesion() {
        Swal.fire({
          title: 'Cerrar sesión',
          html: 'Desea cerrar sesión ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Si, cerrar sesión',
          cancelButtonText: 'No',
        }).then(result => {
          if (result.isConfirmed) {
            localStorage.removeItem('token_street_shopping');
            this.goView('/login');
          }
        });
      },

      close() {
        this.dialog = false;
      },
      
    }
  }
</script>

<style>
  #map {
    height:100%;
    width:100%
  }

  .my-td-left-class {
    text-align: left !important;
    color:black !important;
  }

  .my-td-right-class {
    text-align: right !important;
    color:red !important;
    background-color: #eafaf1
  }
  
  .text-green input {
    color: red !important;
  }

  .swal2-confirm{
    background-color: green !important;
    color: #FFFFFF !important;
  }
  
  .swal2-cancel{
    background-color: red !important;
    color: #FFFFFF !important;
  }

  .swal2-container {
    z-index: 20000 !important;
  }

  .swal2.timerProgressBar {
    background-color: magenta !important; 
    color:  magenta !important;
    height: 1rem
  }  
</style>